import { FBaseService } from '@kasasa/fbase-components/lib';

export default abstract class DesignVersionedResource extends FBaseService {
    declare designStartDate: string;

    public setDesignStartDate(designStartDate: string) {
      this.designStartDate = designStartDate;
    }
}
